import { OFFICE_JS_VERSION, setupFacade } from './AppSpecificSetup';
import 'owa-addins-osfruntime';

/**
 * dataLocale, hostControl, localizedScriptsUrl, and docUrl are all required parameters but not used by OWA
 */
export function createContextActivationManager(
    userCulture: string,
    notifyHostDelegate: (controlId: string, action: OSF.AgaveHostAction, data: any) => void
): OSF.ContextActivationManager {
    OSF.AppSpecificSetup._setupFacade = setupFacade;
    return new OSF.ContextActivationManager({
        appName: OSF.AppName.OutlookWebApp,
        appVersion: OFFICE_JS_VERSION,
        clientMode: OSF.ClientMode.ReadWrite,
        appUILocale: userCulture,
        lcid: userCulture,
        notifyHost: notifyHostDelegate,
        dataLocale: '',
        hostControl: {},
        localizedScriptsUrl: OSF.getLocalizedStringsFilePath(),
        docUrl: '',
    });
}
